import { createFileRoute } from "@tanstack/react-router";
import { SSOErrorPage, ssoErrorlParamsSchemaValidator } from "../../../pages/sso-error-page";

// handles `/` and `/error`, both of which can be called by BetterAuth
export const Route = createFileRoute("/_no_auth/sso-error/$")({
  component: SSOErrorPage,
  validateSearch: ssoErrorlParamsSchemaValidator,
});
